import React from 'react';
import styles from './styles.module.css';
import { Container } from '../../../components';
const MeetCustomers = () => {
  return (
    <Container>
      <div className={styles.titleContainer}>
        <span className={styles.title}>Meet some Happy Customers</span>
      </div>

      <div className={styles.flexContainer}>
        <div className={styles.review}>
	        <div className={styles.imageContainer}>
		        <img src={'../assets/images/pop5.png'} className={styles.image} alt={"meetCustomerImg"}/>
	        </div>
          <div className={styles.summary}>
            <p>
              This simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's
              standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it
              to make
            </p>
          </div>
	        <div className={styles.summary}>
		        <p className={styles.name}>Name of Customer</p>
	        </div>
        </div>
	      <div className={styles.review}>
		      <div className={styles.imageContainer}>
			      <img src={'../assets/images/pop5.png'} className={styles.image} />
		      </div>

		      <div className={styles.summary}>
			      <p>
				     This simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's
				      standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it
				      to make
			      </p>
		      </div>
		      <div className={styles.summary}>
			      <p className={styles.name}>Name of Customer</p>
		      </div>
	      </div>
	      <div className={styles.review}>
		      <div className={styles.imageContainer}>
			      <img src={'../assets/images/pop5.png'} className={styles.image} />
		      </div>
		      <div className={styles.summary}>
			      <p>
				      This simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's
				      standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it
				      to make
			      </p>
		      </div>
		      <div className={styles.summary}>
			      <p className={styles.name}>Name of Customer</p>
		      </div>
	      </div>
      </div>
    </Container>
  );
};
export default MeetCustomers;
